export default __webpack_public_path__ + "maps-examples-view-annotation-marker-1200-13fd58fd7a7a782f03147df6bc662573.webp";